import { INavbarItem } from "../types";

export const navbarItemsData: INavbarItem[] = [
  { label: "ÚVOD", path: "/homepage", title: "Úvodní stránka" },
  {
    label: "E-PŘIHLÁŠKA",
    children: [
      { label: "Jednotlivec", path: "/form-single" },
      { label: "Skupina", path: "/form-group" },
    ],
    title: "E-přihláška",
  },
  {
    label: "PROGRAM",
    children: [
      { label: "Harmonogram", path: "/schedule" },
      { label: "Program zájezdů", path: "/tours-program" },
      { label: "Program pro TOM", path: "/TOM-program" },
      { label: "Doprovodný program", path: "/accompanied-program" },
    ],
    title: "Program akce",
  },
  {
    label: "TRASY",
    children: [
      {
        label: "Pěší - rodiny s dětmi",
        path: "/pedestrian-families-with-children",
      },
      { label: "Pěší - okruhy", path: "/pedestrian-circuits" },
      { label: "Pěší - jednosměrné trasy", path: "/pedestrian-one-way-routes" },
      { label: "Cyklotrasy", path: "/cycle-routes" },
    ],
    title: "Trasy Hlučínských pochodů",
  },
  {
    label: "INFORMACE",
    children: [
      { label: "Aktuality", path: "/latest-news" },
      { label: "Praktické", path: "/information" },
    ],
    title: "Organizační informace",
  },
  {
    label: "HISTORIE",
    path: "https://www.kct-msk.com/general-5",
    blank: true,
    title: "Historie posledního puchýře",
  },
  {
    label: "TIPY",
    children: [
      { label: "Odkazy", path: "/attractions-links" },
      { label: "Zajímavosti", path: "/attractions" },
    ],
    title: "Tipy",
  },
  { label: "KE STAŽENÍ", path: "/downloads", title: "Ke stažení" },
  { label: "KONTAKTY", path: "/contacts", title: "Kontakty" },
];
